/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import './Support.css';
import './ShipmentTrack.css';
import { useHistory } from 'react-router-dom';
import { useAuth } from '@isocel/front-common';
import { Badge, Button, Modal } from 'antd';
import { CloudUploadOutlined, LeftOutlined, MessageOutlined, RightOutlined } from '@ant-design/icons';
import moment from 'moment';

import { usePackagingFlow } from '../../context/PackagingFlowContext';
import { createPackagingFlow, updatePackagingFlow } from '../../queries/api/packaging-flow';
import { usePackagingConfig } from '../../queries/package';
import { PackagingFlowDirection } from '../../queries/api/types';
import UploadDocument from '../uploadDocuments/UploadDocuments';
import { useNotification } from '../notification/Notification';
import defaultImage from '../../assets/images/default.png';
import { isFileValid } from '../../utils/utils';

const Support: React.FC = () => {
    const history = useHistory();
    const [items, setItems] = useState<any[]>([]);
    const [comment, setComment] = useState<string>('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const { showNotification } = useNotification();
    const {
        loadingSession,
        selectedStore,
        voucher,
        packageFlow,
        setPackageFlow,
        flowType,
        movementType,
        warehouse,
        selectedProvider,
        selectedParc,
        cmr,
        isUpdatePackage,
        updateComment,
        setUpdateComment,
        selectedSender,
        selectedReciever,
        isModifierVisible,
        setPackageToEdit,
        setIsPackageToEdit,
        setIsModifierClicked,
        uploadedFiles,
    } = usePackagingFlow();
    const { user } = useAuth();
    const { data: packageConfig } = usePackagingConfig();
    const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
    const [isPallateMovement, setPallateMovement] = useState(false);

    const handleNext = async () => {
        if (loading) return; // Prevent multiple clicks
        setLoading(true);
        try {
            const invalidFiles = isFileValid(uploadedFiles);
            if (invalidFiles.length > 0) {
                const firstInvalid = invalidFiles[0];
                showNotification(
                    'error',
                    'Type de fichier non autorisé',
                    `Le fichier suivant n'est pas autorisé : ${firstInvalid.file.name})`
                );
                setLoading(false);
                return;
            }
            const formData = new FormData();
            uploadedFiles.forEach((uploadedFile) => {
                formData.append('file', uploadedFile.file);
            });
            const packages = packageFlow?.packages.filter((pkg) => pkg.shippedQuantity > 0) || [];
            const req = {
                sender: flowType !== 0 ? packageFlow?.sender : warehouse?._id,
                recipient: flowType !== 0 ? packageFlow?.recipient : selectedStore?.id || '',
                user: user?.id || '',
                loadingSession: loadingSession ? loadingSession.id : null,
                transportVoucher: voucher,
                flowType,
                organization: user?.organization?.id,
                packages: packages.map((pkg) => ({
                    ...pkg,
                    goodCount: pkg.shippedQuantity,
                })),
                comment: comment,
                cmr: cmr,
                senderType: packageFlow?.senderType,
                recieverType: packageFlow?.recieverType,
                attachments: uploadedFiles.map((uploadedFile) => ({
                    attachmentType: uploadedFile.type,
                })),
            };
            const files = uploadedFiles.map((uploadedFile) => uploadedFile.file);
            if (isUpdatePackage && packageFlow) {
                await updatePackagingFlow(packageFlow._id as string, req, files);
            } else {
                await createPackagingFlow(req, files);
            }
            const pkg = packageFlow?.packages.filter((pkg) => pkg.shippedQuantity > 0);
            if ((pkg ?? []).length > 0) {
                history.push('/successShipment');
            } else {
                showNotification('error', "Échec de l'analyse", `Veuillez saisir au moins un emballage.`);
            }
        } catch (error) {
            console.error('Error posting shipment data:', error);
        } finally {
            setLoading(false);
        }
    };
    const goBack = () => {
        setIsModifierClicked(true);
        history.push('/shipmentTracking');
        setPackageFlow(packageFlow);
        setUpdateComment(comment); // Save the comment before leaving
        setPackageToEdit(null);
    };
    const showUploadModal = () => {
        setIsUploadModalVisible(true);
    };
    const change = (value: string) => {
        setComment(value);
    };
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {
        if (packageConfig && packageFlow) {
            const onPageLoad = () => {
                const packageMap = new Map(packageFlow?.packages.map((pkg) => [pkg.package, pkg.shippedQuantity]));
                const transformedArray = packageConfig?.packages.map((data) => ({
                    key: `${data.id}-${data.type.name}`, // Generate unique key
                    typeName: data.type.name,
                    id: data.id,
                    shippedQuantity: packageMap.get(data.id) || 0, // Use quantity from the packages array
                    model: data.model,
                    category: data.category,
                    type: data.type,
                }));
                setItems(transformedArray);
                setComment(updateComment || '');
            };

            onPageLoad();
        }
        const pallateMovement = [
            PackagingFlowDirection.Sale,
            PackagingFlowDirection.Destruction,
            PackagingFlowDirection.ShipmentForRepair,
            PackagingFlowDirection.Transfer,
            PackagingFlowDirection.Decrease,
            PackagingFlowDirection.Increase,
        ].includes(flowType);
        setPallateMovement(pallateMovement);
    }, [loadingSession, selectedStore, user, packageConfig, packageFlow, setPackageFlow, flowType, updateComment]);

    const onItemClick = (item: unknown) => {
        setPackageToEdit(item);
        setIsPackageToEdit(true);
        history.push('/shipmentTracking');
    };
    return (
        <>
            <div className="title mb-16">
                <LeftOutlined className="back-icon" onClick={() => history.goBack()} />
            </div>
            <div className="shipment-track support-container bg-dash">
                <div className="content">
                    <header className="header">
                        <div className="location">
                            {isPallateMovement && movementType ? (
                                ['Transfer', 'Increase', 'Decrease'].includes(movementType.name) ? (
                                    <>
                                        <p>{movementType?.label}</p>
                                        <p>Émetteur: {selectedSender?.name}</p>
                                        <p>Destinataire: {selectedReciever?.name}</p>
                                    </>
                                ) : (
                                    <>
                                        <p>{movementType?.label}</p>
                                        <p>Prestataire: {selectedProvider?.name}</p>
                                        <p>Parc palettes: {selectedParc?.name}</p>
                                    </>
                                )
                            ) : (
                                <>
                                    <p>{selectedStore?.name}</p>
                                    {voucher && <p>Bon de transport: {voucher}</p>}
                                    {loadingSession?.trailerNumber && <p>Remorque: {loadingSession.trailerNumber}</p>}
                                </>
                            )}
                        </div>
                        <div className="info">
                            {loadingSession?.createdAt && (
                                <p>
                                    {loadingSession.createdAt.toLocaleDateString()} -{' '}
                                    {loadingSession.createdAt.toLocaleTimeString()}
                                </p>
                            )}
                            {cmr && <p>CMR: {cmr}</p>}
                            {warehouse && <p>Entrepôt: {warehouse.name}</p>}
                            {loadingSession?.transporter?.name && (
                                <p>Transporteur: {loadingSession.transporter.name}</p>
                            )}
                        </div>
                    </header>

                    {/* List Section */}
                    {/* List Section */}
                    <div className="list-section">
                        <h3>Supports & Emballages</h3>
                        {items
                            .filter((item) => item.shippedQuantity > 0)
                            .map((item) => (
                                <div
                                    className="list-item"
                                    key={item.key}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => isModifierVisible && onItemClick(item)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            onItemClick(item);
                                        }
                                    }}
                                >
                                    <div className="item-info pis">
                                        <img
                                            src={item.type?.image || defaultImage}
                                            alt={item.typeName}
                                            className="header-type-image"
                                        />
                                        <span className="bold py-16">{item.typeName}</span>
                                        {item.type !== item.model.name && <span className=" bold py-16">-</span>}
                                        {item.type !== item.model.name && (
                                            <span className="py-16">{item.model.name}</span>
                                        )}
                                    </div>
                                    <div className="p-4">
                                        <span>{item.shippedQuantity}</span>
                                        {isModifierVisible && <RightOutlined className="ml-8 text-primary" />}
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
            <div className="bottom flex flex-col">
                {packageFlow?.comment ? (
                    <>
                        <div className="floating-button">
                            {packageFlow?.flowType === PackagingFlowDirection.ShippedToStore && (
                                <CloudUploadOutlined
                                    className="upload-icon mr-16 text-blue"
                                    onClick={showUploadModal}
                                />
                            )}
                            <Badge count={1} offset={[-5, 5]}>
                                <Button type="primary" shape="circle" icon={<MessageOutlined />} onClick={showModal} />
                            </Badge>
                        </div>
                    </>
                ) : (
                    packageFlow?.flowType === PackagingFlowDirection.ShippedToStore && (
                        <CloudUploadOutlined className="upload-icon text-blue" onClick={showUploadModal} />
                    )
                )}
                <div className="comment-section">
                    <h4>Commentaire</h4>
                    <textarea
                        placeholder="Remarque sur un support"
                        value={comment}
                        onChange={(e) => change(e.target.value)}
                    ></textarea>{' '}
                </div>
                <footer>
                    <div className="action-buttons flex justify-center">
                        {isModifierVisible && <Button onClick={goBack}>Modifier</Button>}
                        <Button type="primary" onClick={handleNext} className="ml-16" disabled={loading}>
                            Valider
                        </Button>
                    </div>
                </footer>
            </div>
            {/* Modal */}
            <Modal
                title="Commentaires"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                getContainer={false}
                className="custom-modal"
            >
                <div className="modal-textarea bg-light-blue ">
                    <div>{packageFlow?.comment || ''}</div>
                    {packageFlow?.createdAt && (
                        <div className="creation-date text-primary">
                            {`${moment(packageFlow.createdAt).format('DD/MM/YYYY')} ${moment(
                                packageFlow.createdAt
                            ).format('HH:mm')}`}
                        </div>
                    )}
                </div>
            </Modal>
            <Modal
                title="Télécharger des documents"
                visible={isUploadModalVisible}
                onCancel={() => {
                    setIsUploadModalVisible(false);
                }}
                footer={null}
                bodyStyle={{ padding: '10px' }}
            >
                <div>
                    <UploadDocument />
                    <div className="mt-8 flex justify-center">
                        <Button
                            type="primary"
                            onClick={() => {
                                setIsUploadModalVisible(false);
                            }}
                        >
                            Suivant
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Support;
